
export default {
  print: {
    print: 'Print',
    segment: 'Segment',
    preparingPrinting: 'Preparing printing',
    readyToPrint: 'Ready to print'
  }
}
